import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M21.612 10.245a.5.5 0 010 .729l-6.87 6.453a.5.5 0 01-.842-.364v-3.247c-2.632 0-8.227.557-11.111 4.991a.42.42 0 01-.35.193v0a.38.38 0 01-.383-.436C2.36 16.624 4.183 8.81 13.9 7.558V4.156a.5.5 0 01.842-.365l6.87 6.454z" stroke="#1E1E23" strokeWidth="1.8" /></svg>);